import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function CtcValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control.value) {
            return null;
        }
        const value = control.value.toString().trim();
        if (!/^\d+(\.\d{1,2})?$/.test(value)) {
            return { invalidCtc: true };
        }
        const numericValue = parseFloat(value);
        if (numericValue < 0 || numericValue > 1000) {
            return { ctcOutOfRange: true };
        }

        return null;
    };
}